import { Component, computed, input } from '@angular/core';
import { WorkflowStepRule } from '@app/modules/core/store/models';

@Component({
  selector: 'topo-workflow-rule-display',
  standalone: true,
  styleUrl: './workflow-rule-display.component.scss',
  template: `
    <div
      class="workflow-rule-display"
      [innerHTML]="displayText()"></div>
  `
})
export class WorkflowRuleDisplayComponent {
  rule = input.required<WorkflowStepRule>();
  displayText = computed(() => this.rule()?.displayText ?? '');
}
